<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-11 10:05:08
-->
<template>
  <!-- 育苗销售概览 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div
          :class="pageType === 'volume' ? 'type-activite' : ''"
          @click="pageType = 'volume'"
        >
          销售量
        </div>
        <div
          :class="pageType === 'customer' ? 'type-activite' : ''"
          @click="pageType = 'customer'"
        >
          客户应收
        </div>
      </div>
      <!-- 销售量 -->
      <VolumePage v-if="pageType === 'volume'" />
      <!-- 客户应收 -->
      <CustomerPage v-if="pageType === 'customer'" />
    </div>
  </div>
</template>

<script>
import VolumePage from "./ym-sales-volume/ym-sales-volume.vue";
import CustomerPage from "./ym-sales-customer.vue";
export default {
  name: "ym-sales",
  data() {
    return {
      pageType: "volume",
    };
  },
  components: {
    VolumePage,
    CustomerPage,
  },
};
</script>

<style lang="less" scoped>
</style>